module.exports = __webpack_public_path__ + "static/media/tom.d015bda2.jpg";